import loadable from '@loadable/component';
import React, {useEffect, useRef} from 'react';
import {
  Text,
  TouchableOpacity,
  SafeAreaView,
  Animated,
  Easing,
  View,
} from 'react-native';
import styles from './AlertBox.style';
import {CustomText} from '../text/Text';
import {selectrootsheettype} from '../../selectors/SheetSelector';
import {useDispatch, useSelector} from 'react-redux';
import {showAlert} from '../../actions/AlertActions';
const SVG = loadable(() => import('../../imports/svg'));

const AlertBox = props => {
  const {icon, message, onRequestClose, title} = props;
  const {sheetId} = useSelector(state => selectrootsheettype(state));
  const dispatch = useDispatch();

  const opacity = useRef(new Animated.Value(0)).current;

  const show = useRef(
    Animated.timing(opacity, {
      toValue: 1,
      duration: 200,
      useNativeDriver: true,
      easing: Easing.ease,
    }),
  ).current;

  const hide = useRef(
    Animated.timing(opacity, {
      toValue: 0,
      duration: 200,
      useNativeDriver: true,
      easing: Easing.ease,
    }),
    () => {
      dispatch(
        showAlert({
          id: '',
          modalProps: {
            icon: '',
            title: '',
            message: '',
          },
        }),
      );
    }
  ).current;

  useEffect(() => {
    if (sheetId === '') {
      show.start();
      setTimeout(() => {
        hide.start(() => onRequestClose());
      }, 5000);
    }
  }, []);

  const switchBorderColor = () => {
    switch (icon) {
      case 'orangeExclamation':
        return '#FFBA4B';
      case 'redExclamation':
        return '#F87878';
      case 'greenTick':
        return '#61D215';
      case 'blueExclamation':
        return '#2BBEF2';
      default:
        return '#F87878';
    }
  };

  if (sheetId !== '') return null;

  return (
    <SafeAreaView style={styles.screen} pointerEvents="box-none">
      <Animated.View
        style={[
          styles.body,
          {
            opacity: opacity,
          },
        ]}>
        <TouchableOpacity
          style={[styles.container, {borderColor: switchBorderColor()}]}
          onPress={() => {
            hide.start(() => onRequestClose());
          }}
          activeOpacity={1}>
          {!!icon && <SVG name={icon} width={24} height={24} />}

          <View style={styles.textContainer}>
            {!!title && (
              <CustomText
                color={'#2F3F53'}
                size={14}
                txtAlign="right"
                font={'700'}
                selectable={false}>
                {title}
              </CustomText>
            )}
            {!!message && (
              <CustomText
                color={'#2F3F53'}
                size={12}
                font={'400'}
                style={styles.text}
                selectable={false}>
                {message}
              </CustomText>
            )}
          </View>
        </TouchableOpacity>
      </Animated.View>
    </SafeAreaView>
  );
};
export default AlertBox;
